/**
 * Live processing status markers emitted by the agent during complex tasks.
 * Format: [STATUS: Analyzing profile context...]
 */

export const STATUS_TAG_RE = /\[STATUS:\s*([^\]]+)\]/gi;

export function extractStatusTags(text: string): string[] {
  const labels: string[] = [];
  let match: RegExpExecArray | null;
  const re = new RegExp(STATUS_TAG_RE.source, 'gi');
  while ((match = re.exec(text)) !== null) {
    const label = match[1]?.trim();
    if (label) labels.push(label);
  }
  return labels;
}

export function stripStatusTags(text: string): string {
  return text.replace(STATUS_TAG_RE, '').replace(/\n{3,}/g, '\n\n').trim();
}

export function latestStatusLabel(text: string): string | null {
  const tags = extractStatusTags(text);
  return tags.length > 0 ? tags[tags.length - 1]! : null;
}
